import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';

const appRoutes: Routes = [
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./views/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'approver',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./views/approver-dashboard/approver-dashboard.module').then(
        (m) => m.ApproverDashboardModule
      ),
  },
  {
    path: 'searcher',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./views/searcher/searcher.module').then((m) => m.SearcherModule),
  },
  {
    path: 'gotoplan',
    loadChildren: () =>
      import('./views/gotoplan/gotoplan.module').then(
        (m) => m.GotoplanRoutingModule
      ),
  },
  {
    path: 'pdf',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./views/view-pdf/view-pdf.module').then((m) => m.ViewPdfModule),
  },
  {
    path: 'gotoplan/:planNumber',
    loadChildren: () =>
      import('./views/gotoplan/gotoplan.module').then(
        (m) => m.GotoplanRoutingModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./views/landing/landing.module').then((m) => m.LandingModule),
  },
  {
    path: ':id/login',
    loadChildren: () =>
      import('./views/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'sessions',
    loadChildren: () =>
      import('./views/sessions/sessions.module').then((m) => m.SessionsModule),
    data: { title: 'Session' },
  },
  {
    path: '**',
    redirectTo: 'sessions/404',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      useHash: false,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 64],
      initialNavigation: 'enabledNonBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
